import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--gap);
`;

export const ButtonWrapper = styled.div``;
